import { Injectable } from '@angular/core'
import { BehaviorSubject, fromEvent, Observable, tap } from 'rxjs'
import { filter, map } from 'rxjs/operators'

@Injectable({ providedIn: 'root' })
export class ScrollService {
  private _containers: {
    [key: string]: {
      element: HTMLElement
      eventHandler: Observable<[number, number]>
    }
  } = {}

  private events: BehaviorSubject<{ [key: string]: [number, number] }> =
    new BehaviorSubject({})

  /**
   * Save the provided container
   * @param {string} name
   * @param {HTMLElement} element
   */
  public registerContainer(name: string, element: HTMLElement): void {
    this._containers[name] = {
      element,
      eventHandler: fromEvent(element, 'scroll').pipe(
        filter((event) => !!event.target),
        map(
          (event) =>
            [
              (event.target as any)['scrollLeft'],
              (event.target as any)['scrollTop'],
            ] as [number, number]
        )
      ),
    }
    this._containers[name].eventHandler
      .pipe(
        tap((event) => {
          const value = this.events.value
          value[name] = event
          this.events.next(value)
        })
      )
      .subscribe()
  }

  /**
   *
   * @param {string} name
   * @param {[number, number]} tuple x, y to scroll to
   */
  public scrollTo(name: string, tuple: [number, number]): void {
    const container = this._containers[name]
    if (container) {
      container.element.scrollTo(tuple[0], tuple[1])
    }
  }

  /**
   * Will return the scroll observable
   * @param name
   */
  public scrollPosition(name: string): Observable<[number, number]> {
    return this.events.pipe(map((value) => value[name]))
  }

  /**
   * Will tell if a container is registered
   * @param name
   */
  public isContainerRegistered(name: string): boolean {
    return !!this._containers[name]
  }
}
